export default {
  SHIPPER: 'shipper',
  USER: 'user',
};
